<template>
    <b-modal size="xl" button-size="sm" :title="title"
        v-model="showTarefaAprovacaoSolicitanteModal" @hidden="cancelar">
        <b-card bg-variant="light">
            <b-card>
                <div>
                    <span style="font-size: 16px">
                        <strong>Devolução:</strong> {{ devolucao.id }}<br />
                        <strong>Solicitante:</strong>
                        {{ devolucao.departamento.descricao }}<br />
                        <strong>Data:</strong> {{ formatarData(tarefa.dataAtual) }}
                    </span>
                </div>
            </b-card>

            <span style="font-size: 16px">
                <strong>Tarefa:</strong> {{ tarefa.tipoTarefaDevolucao.descricao
                }}<br />
                <strong>Status:</strong> {{ tarefa.status.descricao }}<br />
            </span>

            <b-table id="t-tarefa-item" responsive class="mt-2" small :items="itens" :fields="fieldsTabelaItens"
                :busy="this.busy">
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #cell(quantidadeRecebida)="data">
                    <lg-number v-model="data.item.quantidadeRecebida" required :precision="{ min: 0, max: 0 }"
                        :disabled="isVisualizacao" />
                </template>

                <template #cell(lote)="data">
                    <LgFinderPageLote :id="data.item.id" @onselect="loteSelect" v-model="data.item.lote"
                        :produto="data.item.itemDevolucao.almoxarifadoProduto.produto" :almoxarifado="data.item.itemDevolucao.almoxarifadoProduto.almoxarifado
                            " :isDisabled="isVisualizacao" :prefix="title + ' > '" />
                </template>
            </b-table>

            <b-col lg="12" sm="12" class="text-left">
                <b-form-group label-for="textarea-formatter" class="col-12">
                    <label for="textarea-auto-height">Observação:</label>
                    <b-form-textarea :disabled="isVisualizacao" v-model="form.obs">
                    </b-form-textarea>
                </b-form-group>
            </b-col>
        </b-card>

        <template #modal-footer>
            <div class="d-flex w-100 justify-content-center">
                <b-button id="salvar" variant="success" size="sm" pill class="ml-2" @click="salvar"
                    v-if="!isVisualizacao">
                    <b-tooltip target="salvar" title="Salvar"></b-tooltip>
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check2-circle" scale="1.5" />
                    </div>
                </b-button>
                <b-button id="concluir" variant="primary" size="sm" pill class="ml-2" @click="concluir"
                    v-if="!isVisualizacao">
                    <b-tooltip target="concluir" title="Proxima Tarefa"></b-tooltip>
                    <b-icon icon="arrow-right" />
                </b-button>
                <b-button id="cancelar" variant="danger" size="sm" pill class="ml-2" @click="cancelar">
                    <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgNumber from "@/core/components/Inputs/LgNumber.vue"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import LgFinderPageLote from "../../../components/Finders/LgFinderPageLote.vue"

export default {
    components: { LgNumber, LgFinderPageLote },
    mixins: [ListResourceMixin, FormResourceMixin],

    data() {
        return {
            showTarefaAprovacaoSolicitanteModal: true,
            itens: [],
            form: {
                obs: "",
            },
        }
    },

    props: {
        id: Number,
        tarefa: Object,
        uri: String,
        isVisualizacao: {
            type: Boolean,
            default: false,
        },
        devolucao: {
            type: Object,
            required: true,
        },
    },
    async beforeMount() {
        this.$devolucaoTarefa = new ResourceService(
            `/api/devolucoes/${this.devolucao.id}/tarefas`
        )

        this.$tarefaService = new ResourceService("/api/tarefadevolucao")
    },

    async mounted() {
        this.tarefaItens()
        this.form.quantidadeRecebida = this.itens.map(
            item => item.quantidadeRecebida || 0
        )
    },

    computed: {
        fieldsTabelaItens() {
            return [
                {
                    key: "itemDevolucao.almoxarifadoProduto.produto.numero",
                    label: "NÚMERO",
                    tdClass: "py-0",
                    thStyle: "font-size: 16px; font-weight: 600; width: 15%;",
                    tdStyle: "font-size: 13px; width: 10%;",
                },
                {
                    key: "itemDevolucao.almoxarifadoProduto.produto.descricaoResumida",
                    label: "PRODUTO",
                    tdClass: "py-0",
                    thStyle: "font-size: 16px; font-weight: 600; width: 30%;",
                    tdStyle: "font-size: 13px; width: 50%;",
                },
                {
                    key: "lote",
                    label: "LOTE",
                },
                {
                    key: "quantidadeDevolvida",
                    label: "DEVOLVIDO",
                    tdClass: "py-0 text-center",
                    formatter: value => value || "-",
                    thStyle: "font-size: 16px; font-weight: 600; width: 10%;",
                    tdStyle: "font-size: 13px; width: 10%;",
                },
                {
                    key: "itemDevolucao.quantidadeAprovado",
                    label: "APROVADO",
                    tdClass: "py-0 text-center",
                    formatter: value => value || "-",
                    thStyle: "font-size: 16px; font-weight: 600; width: 10%;",
                    tdStyle: "font-size: 13px; width: 10%;",
                },
                {
                    key: "quantidadeRecebida",
                    label: "RECEBIDO",
                    tdClass: "py-0 text-center",
                    formatter: value => value || "-",
                    thStyle: "font-size: 16px; font-weight: 600; width: 10%;",
                    tdStyle: "font-size: 13px; width: 10%;",
                },
            ]
        },

        title() {
            return 'Devolução > Tarefa' + (this.tarefa ? ( "> "+this.tarefa.tipoTarefaDevolucao.descricao) : "")
        },
    },
    methods: {
        async salvar() {
            if (
                this.itens.find(
                    item => !item.quantidadeRecebida || item.quantidadeRecebida <= 0
                )
            ) {
                this.$notify({
                    message: "Verifique se há coerência entre as quantidades.",
                    type: "danger",
                })
                return
            }

            if (
                this.itens.find(
                    item =>
                        item.quantidadeRecebida > item.itemDevolucao.quantidadeAprovado
                )
            ) {
                this.$notify({
                    message:
                        "A quantidade recebida não pode ser maior do que a quantidade aprovada",
                    type: "danger",
                })
                return
            }

            const itens = this.itens.map(item => {
                return {
                    itemDevolucaoId: item.itemDevolucao.id,
                    aceitoPeloSolicitante: item.aceito === true,
                    recusadoPeloSolicitante: item.aceito === false,
                    quantidadeRecebida: item.quantidadeRecebida,
                    lote: item.lote,
                }
            })

            this.busy = true

            await this.$devolucaoTarefa
                .put(`${this.tarefa.id}${this.uri}`, {
                    itensDevolucao: itens,
                    observacao: this.form.obs,
                })
                .then(response => {
                    this.busy = false;
                    if (response.status === 204 || response.status === 200) {
                        this.cancelar()
                        this.$notify({
                            title: "Sucesso",
                            message: "Tarefa salva com sucesso",
                            type: "success",
                        })
                    }
                })
        },

        async tarefaItens() {
            this.busy = true
            await this.$tarefaService.findById(this.tarefa.id).then(response => {
                this.busy = false

                this.form.obs = response.data.obs
                this.itens = response.data.itensDevolucao.map(item => {
                    item.aceito = null
                    item.lote = item.itemDevolucao.lote || null
                    if (item.aceitoPeloSolicitante) {
                        item.aceito = true
                    } else if (item.recusadoPeloSolicitante) {
                        item.aceito = false
                    }
                    return item
                })
            })
        },

        loteSelect(lote) {
            this.itens = this.itens.map(item => {
                if (lote.codAlmoxarifadoProduto) {
                    if (
                        item.itemDevolucao.almoxarifadoProduto.id ===
                        lote.codAlmoxarifadoProduto.id
                    ) {
                        item.lote = lote
                    }
                }
                return item
            })
        },

        isNull(value) {
            return value === undefined || value == null
        },

        async concluir() {
            if (
                this.itens.find(
                    item => !item.quantidadeRecebida || item.quantidadeRecebida <= 0
                )
            ) {
                this.$notify({
                    message: "Verifique se há coerência entre as quantidades.",
                    type: "danger",
                })
                return
            }

            if (
                this.itens.find(
                    item =>
                        item.quantidadeRecebida > item.itemDevolucao.quantidadeAprovado
                )
            ) {
                this.$notify({
                    message:
                        "A quantidade recebida não pode ser maior do que a quantidade aprovada",
                    type: "danger",
                })
                return
            }

            const itens = this.itens.map(
                ({ itemDevolucao, aceito, quantidadeRecebida }) => {
                    let item = {
                        itemDevolucaoId: itemDevolucao.id,
                        lote: itemDevolucao.lote,
                        produtoId: itemDevolucao.almoxarifadoProduto.produto.id,
                        almoxarifadoId: itemDevolucao.almoxarifadoProduto.almoxarifado.id,
                        aceitoPeloSolicitante: false,
                        recusadoPeloSolicitante: false,
                        quantidadeRecebida: quantidadeRecebida,
                    }

                    if (aceito === true) {
                        item.aceitoPeloSolicitante = true
                        item.recusadoPeloSolicitante = false
                    } else if (aceito === false) {
                        item.aceitoPeloSolicitante = false
                        item.recusadoPeloSolicitante = true
                    }

                    return item
                }
            )

            this.busy = true;
            await this.$tarefaService
                .put(`${this.devolucao.id}/tarefas/${this.tarefa.id}/finalizar`, {
                    itens: itens,
                    observacao: this.form.obs,
                })
                .then(response => {
                    this.busy = false;
                    if (response.status === 204 || response.status === 200) {
                        this.cancelar()
                        this.$notify({
                            title: "Sucesso",
                            message: "Tarefa finalizada com sucesso",
                            type: "success",
                        })
                    }
                })
        },
        cancelar() {
            this.showTarefaAprovacaoSolicitanteModal = false
            this.$emit("tarefaAprovacaoFinalizado");
        },

        formatarData(valor) {
            if (!valor) return ""
            const data = new Date(valor)
            const dia = data.getDate().toString().padStart(2, "0")
            const mes = (data.getMonth() + 1).toString().padStart(2, "0")
            const ano = data.getFullYear()
            const hora = data.getHours().toString().padStart(2, "0")
            const minutos = data.getMinutes().toString().padStart(2, "0")
            const segundos = data.getSeconds().toString().padStart(2, "0")
            return `${dia}/${mes}/${ano} ${hora}:${minutos}:${segundos}`
        },
    },
}
</script>
<style lang="scss">
.modal-footer,
.modal-body {
    padding: 0.25rem !important;
}

table {
    .form-control {
        padding: 3px 9px;
        height: 30px;
        text-align: right;
    }
}
</style>
